import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle  from '../assets/circle.svg';

import python_icon      from '../assets/python.png';
import sql             from '../assets/sql-server.png';
import git_lab         from '../assets/social.png';
import machine_learning from '../assets/brain.png';
import statistics      from '../assets/pie-chart.png';

export default {
  about01, about02, about03, about04,
  profile, circle,
  python_icon, sql, git_lab, machine_learning, statistics,
};
